/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PlayroomService {

  apiUrl = environment.apiUrl;
  private playroomsSource = new ReplaySubject<any>(1);
  playrooms$ = this.playroomsSource.asObservable();

  constructor(private http: HttpClient) { }

  getAllPlayrooms() {
    return this.http.get(this.apiUrl + 'room').pipe(map((rooms) => {
      if(rooms) {
        this.playroomsSource.next(rooms);
      }
    })).toPromise();
  }

}
